const messages = {
  ticket: 'No. de ticket',
  socialReasons: 'Razón social',
  rfc: 'RFC'
}

export default messages
